module.exports = __webpack_public_path__ + "img/prize-04.8c449c70.png";